import { useState, useEffect } from 'react'
import { getMeetings, createMeeting, updateMeeting, deleteMeeting } from '../supabase/api'

export function useMeetings(pairId, userId) {
  const [meetings, setMeetings] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!pairId) { setLoading(false); return }
    fetchMeetings()
  }, [pairId])

  const fetchMeetings = async () => {
    try {
      setLoading(true)
      const data = await getMeetings(pairId)
      setMeetings(data)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const addMeeting = async (meetingData) => {
    const data = await createMeeting(pairId, userId, meetingData)
    setMeetings(prev => [...prev, data])
    return data
  }

  const editMeeting = async (meetingId, updates) => {
    const data = await updateMeeting(meetingId, updates)
    setMeetings(prev => prev.map(m => m.id === meetingId ? data : m))
    return data
  }

  const removeMeeting = async (meetingId) => {
    await deleteMeeting(meetingId)
    setMeetings(prev => prev.filter(m => m.id !== meetingId))
  }

  return { meetings, loading, error, addMeeting, editMeeting, removeMeeting, refetch: fetchMeetings }
}